<template>
  <div>
            <el-dialog
            :title="title"
            :visible.sync="visibleSync"
            :width="width"
            :close-on-click-modal="false"
            :destroy-on-close="true"
            :before-close="beforeClose"
            v-if="visibleSync"
        >
       <el-form ref="form" :model="AddSurgeryTip" label-position="left" label-width="70px">
            <el-row>
            <el-col :span="12">
            <el-form-item label="标签名称" required>
                <el-input v-model="AddSurgeryTip.tip_name" placeholder="请输入标签名称"></el-input>
            </el-form-item>
            </el-col>
            <el-col :span="8">
            <el-form-item label="背景色" label-width="60px" required>
                <el-color-picker
                v-model="AddSurgeryTip.tip_color"
                show-alpha
                :predefine="predefineColors">
                </el-color-picker>
            </el-form-item>
            </el-col>
            </el-row>
            <el-form-item label="备注说明" required>
                <el-input v-model="AddSurgeryTip.remark" placeholder="标签备注说明"></el-input>
            </el-form-item>
            <div style="width: 100%; text-align: right; margin-bottom: 20px">
                <!-- <el-button style="margin-left: 10px;" @click="openTemp">从模板库创建</el-button> -->
                <el-button style="margin-left: 10px" @click="visibleSync = false">取消</el-button>
                <el-button type="primary" style="margin-left: 10px" @click="confirm()">确定</el-button>
            </div>
        </el-form>
      </el-dialog>
  </div>
</template>

<script>

export default {
    name: `SurgeryTips`,
    props: {
        dialogVisible: { type: Boolean, default: false },
        surgeryId: { type: Number },
        patientInfo: { type: String },
        width: {
            type: String,
            default: `30%`
        }
    },
    data() {
        return {
            AddSurgeryTip: {
                biz_surgeryInfo_id: 0,
                tip_name: ``,
                tip_color: `rgba(255, 69, 0, 0.68)`,
                remark: ``
            },
            predefineColors: [
                `#ff4500`,
                `#ff8c00`,
                `#ffd700`,
                `#90ee90`,
                `#00ced1`,
                `#1e90ff`,
                `#c71585`,
                `rgba(255, 69, 0, 0.68)`,
                `rgb(255, 120, 0)`,
                `hsv(51, 100, 98)`,
                `hsva(120, 40, 94, 0.5)`,
                `hsl(181, 100%, 37%)`,
                `hsla(209, 100%, 56%, 0.73)`,
                `#c7158577`
            ],
            aaaa: []
        }
    },
    computed: {
        title() {
            return `添加患者标签${this.patientInfo}`
        },
        visibleSync: {
            get: function() {
                return this.dialogVisible
            },
            set: function(newval) {
                if (newval == false) {
                    this.AddSurgeryTip.biz_surgeryInfo_id = 0
                    this.AddSurgeryTip.tip_name = ``
                    this.AddSurgeryTip.tip_color = `rgba(255, 69, 0, 0.68)`
                    this.AddSurgeryTip.remark = ``
                }
                this.$emit(`update:dialogVisible`, newval)
            }
        }
    },
    methods: {
        beforeClose() {
            this.visibleSync = false
            this.$emit(`afterClose`)
        },
        confirm() {
            this.AddSurgeryTip.biz_surgery_info_id = this.surgeryId
            let req = this.myaxios.post(`/api/AcisSystem/BizSurgeryTips/Post`, this.AddSurgeryTip)
            req.then(data => {
                if (data) {
                    this.$message({
                        type: `success`,
                        message: `患者标签新增成功`
                    })
                    this.beforeClose()
                }
            }).catch(e => {
                console.log(e)
            })
        }
    }

}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/common/SurgeryTips.vue